/* Close the native mobile drawer only for this homepage's in-page inspiration link. */
(() => {
  if (window.inlightHomeV2Bound) return;
  window.inlightHomeV2Bound = true;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#MenuDrawer a[data-inlight-home-link]');
    if (!link) return;
    const target = new URL(link.href, location.href);
    if (target.origin === location.origin && target.pathname === location.pathname && target.hash) {
      document.querySelector('#MenuDrawer button.drawer__close[aria-controls="MenuDrawer"]')?.click();
    }
  });
})();
